import styled from 'styled-components';

export const ChatPanelsContainer = styled.div<{ showList: boolean }>`
  display: flex;
  width: 200%;
  height: 100%;
  transition: transform 0.3s ease;
  transform: translateX(${({ showList }) => showList ? '0' : '-50%'});
`;

export const Panel = styled.div`
  width: 50%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ChatListHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
  }
`;

export const SearchContainer = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
`;

export const ChatList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`;

export const StyledChatItem = styled.div`
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: #f5f5f5;
  }

  h3 {
    margin: 0;
    font-size: 16px;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #999;
  }

  & + & {
    margin-top: 8px;
  }
`;

export const ChatItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ChatItemActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const FloatingHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 12px;

  h2 {
    margin: 0;
  }
`;
